import * as Yup from 'yup'
import { formatDateYMD } from '../../utils/dateFormatter'
import { GAME_AGGREGATORS } from '../../constants/aggregators'

export const giveBonusSchema = () => Yup.object().shape({
  includeUserIds: Yup.array().min(1, 'Segment Id Required!').required('Segment Id Required!')
})

export const giveFreespinSchema = (selectedAggregator) => () => Yup.object().shape({
  includeUserIds: Yup.array().min(1, 'Segment Id Required!').required('Segment Id Required!'),
  quantity: Yup.number()
    .min(1, 'Minimum 1 Spin Required')
    .positive('Spins Must be a Positive Number')
    .integer('Spins Must be an Integer Value')
    .required('Spins Required'),
  betLevel: Yup.number().when([], {
    is: true,
    then: Yup.number().when([], {
      is: () => selectedAggregator === GAME_AGGREGATORS.IGD.NAME,
      then: Yup.number()
        .moreThan(0, 'Value must be greater than 0')
        .required('Bet Level Required'),
      otherwise: Yup.number()
        .min(1, 'Minimum value must be 1')
        .integer('Only Integer Values Allowed')
        .required('Bet Level Required')
    })
  }),
  bonusId: Yup.string().required('Bonus Required'),
  validFrom: Yup.date()
    .min(formatDateYMD(new Date()), "Valid From Must be Greater Than or Equal To Today's Date")
    .nullable(),
  validTo: Yup.date()
    .test('isSmall',
      'Valid To Must Be Greater Than Valid From',
      (value, context) => {
        if (value.getTime() <= context.parent.validFrom.getTime()) {
          return false
        } else {
          return true
        }
      })
    .test('isLess',
      'Valid To Must Be In The Range Of One Month From Valid From Date',
      (value, context) => {
        const validFromDate = context.parent.validFrom
        validFromDate.setDate(validFromDate.getDate() + 30)
        if (value.getTime() <= validFromDate.getTime()) {
          return true
        } else {
          return false
        }
      })
})
